import { Circle, Fill, Icon, Stroke, Style } from 'ol/style';
import { type Type as GeometryType } from 'ol/geom/Geometry';
import { getAtonStyle, getVirtualAtonStyle } from './getStyle';

export enum DrawingStyles {
  Normal = 'normal',
  aton = 'aton',
  VirtualAton = 'virtualAton',
}

export function getDrawingStyle(
  drawingStyle: DrawingStyles,
  geometryType: GeometryType
): Style[] {
  if (drawingStyle === DrawingStyles.VirtualAton) {
    return [getVirtualAtonStyle()];
  } else if (drawingStyle === DrawingStyles.aton) {
    return [getAtonStyle()];
  } else {
    switch (geometryType) {
      case 'Point':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.4)',
              }),
              stroke: new Stroke({
                color: '#3399CC',
                width: 1.25,
              }),
            }),
          }),
        ];

      case 'LineString':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.4)',
              }),
              stroke: new Stroke({
                color: '#3399CC',
                width: 1.25,
              }),
            }),
            stroke: new Stroke({
              color: '#3399CC',
              width: 1.25,
            }),
          }),
        ];

      case 'Polygon':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.4)',
              }),
              stroke: new Stroke({
                color: '#3399CC',
                width: 1.25,
              }),
            }),
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.4)',
            }),
            stroke: new Stroke({
              color: '#3399CC',
              width: 1.25,
            }),
          }),
        ];

      case 'Circle':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.4)', // Default OpenLayers point fill color
              }),
              stroke: new Stroke({
                color: '#3399CC', // Default OpenLayers point stroke color
                width: 1.25,
              }),
            }),
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.4)', // Default OpenLayers circle fill color
            }),
            stroke: new Stroke({
              color: '#3399CC', // Default OpenLayers circle stroke color
              width: 1.25,
            }),
          }),
        ];

      default:
        return [
          new Style({
            stroke: new Stroke({
              color: '#3399CC', // Fallback default OpenLayers stroke color
              width: 1.25,
            }),
          }),
        ];
    }
  }
}
